import { makeEntityScaffold } from '@classpass/saga-tools';
import { CancelStep } from 'features/Settings/Membership/Update/Cancel/step/models/CancelStep';

export const cancelFlowStep = makeEntityScaffold(
  'SAGA.API.CANCEL_FLOW.STEP',
  (client, userId, params) => client.bff.getCancelFlowStep(userId, params).then(data => data),
  {
    defaultKey: (client, userId, params) => params.step_id,
    mapData: data => data && new CancelStep(data),
  }
);

export const saveCancelReasonCode = makeEntityScaffold(
  'SAGA.API.CANCEL_FLOW.SET_CANCEL_REASON_CODE',
  (client, userId, params) => client.bff.saveCancelReasonCodeV2(userId, params).then(data => data)
);

export const cancelFlowUserAttributes = makeEntityScaffold('SAGA.API.CANCEL_FLOW.USER_ATTRIBUTES', (client, userId) =>
  client.bff.getUserAttributes(userId).then(data => data)
);

export const cancelFlowIsExcludedFromTest = makeEntityScaffold(
  'SAGA.API.CANCEL_FLOW.ELIGIBILITY_OVERRIDE',
  (client, userId) => client.bff.getEligibility(userId).then(data => data)
);
